
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.632 4.408A4.674 4.674 0 007.002.333C5.166.333 3.57 1.407 2.842 3.1 1.409 3.528.336 4.88.336 6.333A3.337 3.337 0 003.67 9.667h.667V8.333H3.67c-1.102 0-2-.897-2-2 0-.936.8-1.838 1.782-2.01l.388-.068.128-.372c.468-1.368 1.632-2.216 3.036-2.216A3.337 3.337 0 0110.336 5v.667h.667c.735 0 1.333.598 1.333 1.333s-.598 1.333-1.333 1.333H9.669v1.334h1.334A2.67 2.67 0 0013.669 7c0-1.254-.87-2.308-2.037-2.592z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.67 6.333V3.667H6.335v2.666h-2l2.667 3.334 2.666-3.334h-2z","fill":"#fff"}})])
          )
        }
      }
    